import { useEffect, useState } from "react";
import Home from "./pages/Home";
import Recommend from "./pages/Recommend";
import Browse from "./pages/Browse";
import ApiTestLab from "./pages/ApiTestLab";

type Route = "home" | "recommend" | "browse" | "lab";

function routeFromHash(): Route {
  switch (window.location.hash) {
    case "#/recommend":
      return "recommend";
    case "#/browse":
    case "#/app":
      return "browse";
    case "#/lab":
      return "lab";
    default:
      return "home";
  }
}

export default function App() {
  const [route, setRoute] = useState<Route>(routeFromHash);

  useEffect(() => {
    const onHash = () => setRoute(routeFromHash());
    window.addEventListener("hashchange", onHash);
    return () => window.removeEventListener("hashchange", onHash);
  }, []);

  return (
    <div className="app">
      <nav className="topnav">
        <div className="brand">
          <a href="#/" style={{ textDecoration: "none", color: "inherit" }}>
            GameChooser
          </a>
        </div>
        <div>
          <a href="#/">Home</a>
          <a href="#/recommend">Recommend</a>
          <a href="#/browse">Browse</a>
          <a href="#/lab">API Test Lab</a>
        </div>
      </nav>
      {route === "home" && <Home />}
      {route === "recommend" && <Recommend />}
      {route === "browse" && <Browse />}
      {route === "lab" && <ApiTestLab />}
    </div>
  );
}
